import PropTypes from "prop-types";


//import styles from "./Heading.module.scss";

export const Heading = ({
  children,
  className,
  color,
  tag,
  size,
  uppercase,
}) => {
  const Heading = tag;
  if (!children) {
    return false;
  }


  return <Heading >{children}</Heading>;
};

Heading.propTypes = {
  tag: PropTypes.node.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.oneOf(["white"]),
  size: PropTypes.string,
  uppercase: PropTypes.bool,
};
